
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"30","height":"30","rx":"15","fill":"#EAEDFF"}}),_c('path',{attrs:{"d":"M8.153 7.522L15 6l6.847 1.522a.833.833 0 01.653.813v8.322a5 5 0 01-2.227 4.16L15 24.334l-5.274-3.515a5 5 0 01-2.226-4.16V8.334c0-.39.271-.729.653-.813zM15 14.333a2.083 2.083 0 100-4.166 2.083 2.083 0 000 4.166zM11.273 18.5h7.454a3.75 3.75 0 00-7.454 0z","fill":"#2B4BFF"}})])
          )
        }
      }
    